/* Mirror the native Dawn purchase control, including loading, errors and sold-out states. */
if (!customElements.get('fk-sticky-cart')) {
  customElements.define('fk-sticky-cart', class extends HTMLElement {
    connectedCallback() {
      this.main = this.closest('product-info');
      this.button = this.querySelector('[data-sticky-buy]');
      this.original = this.main?.querySelector('[id^="ProductSubmitButton-"]');
      if (!this.original || !this.button) return;
      this.onBuy = () => { if (!this.original.disabled && this.original.getAttribute('aria-disabled') !== 'true') this.original.click(); };
      this.button.addEventListener('click', this.onBuy);
      this.sync = () => {
        const unavailable = this.original.disabled || this.original.getAttribute('aria-disabled') === 'true';
        this.button.disabled = unavailable;
        this.button.textContent = this.original.querySelector('span')?.textContent.trim() || this.original.textContent.trim();
        const price = this.main.querySelector('.price--on-sale .price-item--sale') || this.main.querySelector('.price-item--regular');
        this.querySelector('[data-sticky-price]').textContent = price?.textContent.trim() || '';
      };
      this.onScroll = () => { this.hidden = this.original.getBoundingClientRect().bottom >= 0; };
      this.observer = new MutationObserver(() => { this.sync(); this.onScroll(); });
      this.observer.observe(this.main.querySelector('.product__info-container'), {subtree:true,childList:true,attributes:true,characterData:true});
      window.addEventListener('scroll', this.onScroll, {passive:true});
      window.addEventListener('resize', this.onScroll, {passive:true});
      this.sync();this.onScroll();
    }
    disconnectedCallback() {
      this.observer?.disconnect();
      this.button?.removeEventListener('click', this.onBuy);
      window.removeEventListener('scroll', this.onScroll);
      window.removeEventListener('resize', this.onScroll);
    }
  });
}
